export const obtenerValorProductos = (productos) => {

    let valor = 0;
    for (let i = 0; i < productos.length; i++) {
        let pord = productos[i]
        valor += parseInt(pord.cantidad) * parseInt(pord.valor)
    }

    return valor;

}